<template>
  <header class="head">
    <div class="head-img-contain">
      <img  :src="detail.cover" width="100%"/>
    </div>
    <div class="model-info-box">
      <img class="head-img" :src="detail.cover" width="60" />
      <aside>
        <h4 class="model-name">{{ detail.name }}</h4>
        <p class="model-info">{{ detail.base }}</p>
      </aside>
    </div>
  </header>
</template>
<script>
  export default {
    props: {
      detail: Object
    },
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .head {
    background-color: #FFF;
  }
  .head-img-contain {
    height: 250px;
    overflow-y: hidden;
    img {
      opacity: .7;
    }
  }
  .model-info-box {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    transform: translateY(-50%);
    width: px2rem(345px);
    margin: 0 auto;
    padding: 10px;
    border: 1px solid #d6d6d6;
    border-radius: 5px;
    background-color: #fff;
    .head-img {
      border-radius: 30px;
      margin-right: 10px;
    }
    .model-info {
      font-size: 12px;
      color: #ACACAC;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ModelInfoTwo.vue